import { EndpointSetting } from "@/constants/app/type";
import { FlightState } from "../type";

export const callbackGetExchangeCurrency: EndpointSetting['caller'] = (
  state: FlightState,
  action: any,
  endpointName: any
) => {
  state.get_exchange_currency.loading = false
  state.get_exchange_currency.error = null
  state.get_exchange_currency.success = true
  state.get_exchange_currency.called = true
  state.get_exchange_currency.data = action.payload
  localStorage.setItem('currency', JSON.stringify(action.payload))
}